<template>
    <UFileUpload
        :model-value="files"
        label="Dra og slipp filer her"
        description="Opplasting av fil oppretter ny oppgave"
        class="mb-2"
        multiple
        reset
        layout="list"
        :ui="{
            avatar: 'hidden',
            file: 'bg-default'
        }"
        @update:model-value="onFilesUpdated"
    >
        <template #actions>
            <UButton
                icon="i-ph-upload"
                label="Velg filer"
                variant="outline"
                color="neutral"
            />
        </template>

        <template #files-bottom="{ removeFile }">
            <div v-if="showActionButtons" class="flex gap-2 justify-end w-full">
                <UButton
                    variant="outline"
                    color="neutral"
                    :label="`Fjern alle filer (${files?.length ?? 0})`"
                    @click="removeFile()"
                />
                <UButton
                    :label="`Opprett oppgaver (${ files?.length ?? 0})`"
                    @click="handleUpload"
                />
            </div>
        </template>
    </UFileUpload>
</template>

<script setup lang="ts">

import {onMounted, ref} from 'vue'
import {fileUploadBatch, storageGetFile} from '@/services/document.service'
import {getDocumentMeta} from '@/services/infrastructure/storage.service'

const files = ref<File[]>()
const fileToUuid = new Map<File, string>()

const props = defineProps({
    showActionButtons: {
        type: Boolean,
        default: true
    },
    docMetaUuids: {
        type: Array as () => string[],
        required: false
    }
})

const emit = defineEmits(['uploadSuccess', 'filesChanged', 'removedUuid'])

onMounted(async () => {
    if (!props.docMetaUuids?.length) return
    const loaded: File[] = []
    for (const uuid of props.docMetaUuids) {
        const meta = await getDocumentMeta(uuid)
        if (meta) {
            const file = await storageGetFile(meta)
            fileToUuid.set(file, uuid)
            loaded.push(file)
        }
    }
    files.value = [...loaded]
})

const onFilesUpdated = (newFiles: File[] | null | undefined) => {
    const updated = newFiles ?? []
    const removed = (files.value ?? []).filter(f => fileToUuid.has(f) && !updated.includes(f))
    removed.forEach(f => emit('removedUuid', fileToUuid.get(f)!))
    files.value = updated
    const newlyAdded = updated.filter(f => !fileToUuid.has(f))
    emit('filesChanged', newlyAdded)
}

const handleUpload = async () => {
    const newDocs = await fileUploadBatch(files.value!)
    emit('uploadSuccess', newDocs)
    files.value = []
    fileToUuid.clear()
}

</script>

<style scoped>

</style>